export default "__VITE_ASSET__DQPatEu1__"